import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { captureException } from '@sentry/browser'

import { findBranchById } from 'features/Branch/service'
import { initTicketDetail } from 'features/Ticket'
import { getFullAddress } from 'helpers/address'
import { CONTACT_TYPE } from 'types'
import renderCustomerInfo from './renderCustomerInfo'

import type {
  ICustomerInfo,
  CustomerBranch,
  ITicketCustomerInfo,
} from './model'

const TicketCustomerInfo: React.FC<ITicketCustomerInfo> = (
  props: ITicketCustomerInfo,
) => {
  const [branch, setBranch] = useState<CustomerBranch>(initTicketDetail)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { t } = useTranslation(['layout'])

  const { branchId, ticketDetail } = props

  const base = 'f-ticket-customer-info'

  useEffect(() => {
    setIsLoading(true)

    if (branchId) {
      fetchBranch(branchId)
    }
  }, [branchId])

  const fetchBranch = async (id: string) => {
    try {
      const { data = [] } = await findBranchById(id)
      const branch = data as CustomerBranch

      setBranch(branch)
      setIsLoading(false)
    } catch (error) {
      captureException(error)
    }
  }

  const { companyName, name, addresses, contacts } = branch
  const contactPhone = contacts?.find(
    (contact) => contact.type === CONTACT_TYPE.CONTACT_PHONE,
  )
  const email = contacts?.find((contact) => contact.type === CONTACT_TYPE.EMAIL)
  let address = ''

  if (addresses[0]) {
    address = getFullAddress('th', addresses[0], {
      hasCountry: false,
    })
  }

  const content: ICustomerInfo = {
    companyName,
    reporterName: ticketDetail?.contactName,
    branchName: name,
    branchPhoneNumber: contactPhone?.number,
    email: email?.email,
    address,
    reporterPhoneNumber: ticketDetail?.contactPhoneNumber,
  }

  return (
    <div className={base} data-testid='customer-info'>
      <span className={`${base}__title`}>
        {t('layout:ticketDetail.breadcrumb')}
      </span>
      <div
        className={clsx(
          `${base}__content`,
          isLoading && `${base}__content--loading`,
        )}
      >
        {renderCustomerInfo(content, isLoading)}
      </div>
    </div>
  )
}

export default TicketCustomerInfo
